import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "./Logo";

const links = [
  { label: "Home", type: "route", to: "/" },
  { label: "Store Locator", type: "anchor", hash: "#locateUs" },
  { label: "About", type: "anchor", hash: "#aboutUs" },
  { label: "Contact", type: "anchor", hash: "#contactUs" },
];

function Header({ menuOpen, setMenuOpen }) {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goAnchor = (hash) => (e) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: hash } });
    } else {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const goRoute = () => setMenuOpen(false);

  return (
    <header className={`header ${scrolled ? "header--scrolled" : ""}`}>
      <div className="header__inner">
        <Link to="/" className="header__brand" onClick={goRoute}>
          <Logo />
        </Link>

        <button
          className={`header__burger ${menuOpen ? "is-open" : ""}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`nav ${menuOpen ? "nav--open" : ""}`}>
          <ul className="nav__list">
            {links.map((l) => (
              <li key={l.label} className="nav__item">
                {l.type === "route" ? (
                  <Link
                    className={`nav__link ${
                      location.pathname === l.to ? "nav__link--active" : ""
                    }`}
                    to={l.to}
                    onClick={goRoute}
                  >
                    {l.label}
                  </Link>
                ) : (
                  <a
                    className="nav__link"
                    href={l.hash}
                    onClick={goAnchor(l.hash)}
                  >
                    {l.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
